import get from 'lodash/get';
import rosterService from 'app/services/roster';
import { sortByName } from 'utils/sort-by-name';
import recognitionService from 'app/services/recognition';
import { endLoading, startLoading } from 'app/app-dux/app-dux';
import { CLEAR_RECOGNITION } from 'app/app-dux/recognition-dux';

/*******************************************************************************
 * Initial state
 */
const initialState = {
	myTeam: [],
	searchedPeople: [],
	selectedPeople: [],
	ineligibleRecipients: [],
	hasSelectedPeople: false,
	hasSelectedRecipients: false
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_MY_TEAM = 'SET_MY_TEAM';
export const REMOVE_SELECTED_PEOPLE = 'REMOVE_SELECTED_PEOPLE';
export const SET_SEARCHED_PEOPLE = 'SET_SEARCHED_PEOPLE';
export const SET_SELECTED_PEOPLE = 'SET_SELECTED_PEOPLE';
export const SET_INELIGIBLE_RECIPIENTS = 'SET_INELIGIBLE_RECIPIENTS';
export const ADD_AWARD_TO_PERSON = 'ADD_AWARD_TO_PERSON';

/*******************************************************************************
 * Reducer
 */
export default function peopleReducer( state = initialState, action ) {
	switch ( action.type ) {
		case SET_MY_TEAM: {
			return {
				...state,
				myTeam: action.myTeam
			};
		}
		case SET_SEARCHED_PEOPLE: {
			return {
				...state,
				searchedPeople: action.people
			};
		}
		case SET_SELECTED_PEOPLE: {
			return {
				...state,
				selectedPeople: [ ...state.selectedPeople ].concat( action.selectedPeople ),
				hasSelectedPeople: true
			};
		}
		case REMOVE_SELECTED_PEOPLE: {
			const selectedPersonId = action.selectedPeople.id || action.selectedPeople.value;
			const s = state.selectedPeople.filter( person => person.id !== selectedPersonId );
			return {
				...state,
				selectedPeople: state.selectedPeople.filter( person => person.id !== selectedPersonId ),
				hasSelectedPeople: s.length > 0,
				noParticipantsSelected: s.length === 0
			};
		}
		case SET_INELIGIBLE_RECIPIENTS: {
			return {
				...state,
				ineligibleRecipients: action.ineligibleRecipients
			};
		}
		case ADD_AWARD_TO_PERSON: {
			return {
				...state,
				selectedPeople: state.selectedPeople?.map( ( person, i ) => {
					if ( person.id === action.personId ) {
						return {
							...person,
							awardValue: action.awardValue
						};
					} else {
						return person;
					}
				} )
			};
		}
		case CLEAR_RECOGNITION: {
			return {
				...state,
				selectedPeople: [],
				hasSelectedPeople: false,
				ineligibleRecipients: []
			};
		}
		default:
			return state;
	}
}

/*******************************************************************************
 * Action creators
 */
export const setMyTeam = myTeam => ( { type: SET_MY_TEAM, myTeam } );
export const removeSelectedPeople = ( selectedPeople ) => ( { type: REMOVE_SELECTED_PEOPLE, selectedPeople } );
export const setSearchedPeople = people => ( { type: SET_SEARCHED_PEOPLE, people } );
export const setSelectedPeople = selectedPeople => dispatch => ( dispatch( { type: SET_SELECTED_PEOPLE, selectedPeople } ) );
export const setIneligibleRecipients = ineligibleRecipients => dispatch => ( dispatch( { type: SET_INELIGIBLE_RECIPIENTS, ineligibleRecipients } ) );
export const setPersonPoints = ( personId, awardValue ) => ( { type: ADD_AWARD_TO_PERSON, personId, awardValue } );
export const getTeamMembers = () => async ( dispatch ) => {
	try {
		const personNodeId = await dispatch( getPersonNodeId( localStorage.getItem( 'personId' ) ) );
		if ( personNodeId ) {
			return dispatch( getPeopleFromNode( personNodeId ) );
		}
	} catch ( err ) {
		console.error( err );
	}
};

export const getPeopleFromNode = ( nodeId ) => async ( dispatch ) => {
	try {
		console.info( 'person node Id:', nodeId );
		const response = await rosterService.getTeamMembers( nodeId );
		if ( response ) {
			const filteredTeamMembers = response.filter( ( person ) => person.id !== localStorage.getItem( 'personId' ) );
			const sortedList = sortByName( filteredTeamMembers );
			dispatch( setMyTeam( sortedList ) );
			return sortedList;
		}
	} catch ( error ) {
		console.error( error );
	}
};

export const getPersonNodeId = ( personId = localStorage.getItem( 'personId' ) ) => async ( dispatch ) => {
	let nodeId = '';
	try {
		const response = await recognitionService.getPersonDetail( personId );
		if ( response.success ) {
			nodeId = response.nodes[ 0 ].id;
		}
		return nodeId;
	} catch ( error ) {
		console.error( error );
	}
};

export const searchParticipant = ( searchText ) => async dispatch => {
	dispatch( startLoading() );
	try {
		const response = await recognitionService.searchParticipants( searchText );
		if ( response.success ) {
			console.info( 'Searched results', response.persons );
			dispatch( setSearchedPeople( response.persons ) );
		}
	} catch ( error ) {
		console.error( error );
	} finally {
		dispatch( endLoading() );
	}
};

// selectors
export const getMyTeam = state => get( state, 'people.myTeam', [] );
export const getSelectedPeople = state => get( state, 'people.selectedPeople', [] );
export const getHasSelectedPeople = state => get( state, 'people.hasSelectedPeople', false );
export const getIneligibleRecipients = state => get( state, 'people.ineligibleRecipients', [] );
export const getSearchedPeople = state => get( state, 'people.searchedPeople', [] );